// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"ow_a bie_a bie_x","FilterForm__vgroup":"ow_b bie_sv"};